import Layout from "../components/Layout";

export default function GatewayPage() {
  return (
    <Layout>
      {/* Hero */}
      <section className="hero">
        <div className="hero-text">
          <h1>Gateway Software Download</h1>
          <p>
            Download the latest version of GFM Stock Control Gateway Software.
          </p>
        </div>
      </section>

      {/* Downloads */}
      <section className="intro-section">
        <h2>Download Links</h2>
        <p>
          Please choose the appropriate installer for your system:
        </p>
        <ul>
          <li>
            <a
              href="/assets/Gateway/Gateway Setup 1.1.5.exe"
              download="Gateway.exe"
              className="contactLink"
            >
              Gateway Software 1.1.5 (EXE Installer) – 04/07/2025
            </a>
          </li>
          <li>
            <a
              href="/assets/Gateway/Gateway 1.1.5.msi"
              download="Gateway.msi"
              className="contactLink"
            >
              Gateway 1.1.5 MSI (For Adam Only) – 04/07/2025
            </a>
          </li>
        </ul>
        <p>
          <em>
            For best results, please access this page from a desktop device.
          </em>
        </p>
      </section>

      {/* Contact */}
      <section className="contact-cta">
        <h2>Need Help Installing?</h2>
        <a className="contactLink" href="/contact">
          Contact Support
        </a>
      </section>
    </Layout>
  );
}
